import { Award, Scale, Users, LifeBuoy } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const RAZONES = [
  {
    icon: Award,
    titulo: "Experiencia que se hereda",
    texto: "Tres generaciones resolviendo siniestros, reclamaciones y trámites.",
  },
  {
    icon: Scale,
    titulo: "Asesoría imparcial",
    texto: "Comparamos varias aseguradoras y te explicamos sin letra chiquita.",
  },
  {
    icon: Users,
    titulo: "Trato personal",
    texto: "Hablas con personas que conocen tu póliza y tu historia, no con un call center.",
  },
  {
    icon: LifeBuoy,
    titulo: "Te acompañamos en el siniestro",
    texto: "Cuando algo pasa, nosotros estamos contigo para asesorarte.",
  },
];

export const PorQue = () => (
  <section data-testid="porque-section" className="bg-[#E8F6FD] py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#1BA8E0]">
          Por qué Seguclick
        </p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#0C5F8A] sm:text-3xl lg:text-4xl">
          La experiencia de 60 años, la facilidad de un clic
        </h2>
      </Reveal>

      <div className="mt-14 grid items-center gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-16">
        <Reveal className="relative mx-auto w-full max-w-md lg:mx-0">
          <div className="pointer-events-none absolute -left-6 -top-6 h-28 w-28 rounded-3xl bg-[#F5B21B]/25" aria-hidden="true" />
          <img
            src={IMAGES.porque1}
            alt="Asesora de seguros platicando con una familia en su hogar"
            loading="lazy"
            className="relative w-full -rotate-2 rounded-2xl object-cover shadow-[0_24px_50px_-16px_rgba(12,95,138,0.35)] transition-transform duration-500 hover:rotate-0"
          />
          <img
            src={IMAGES.porque2}
            alt="Abuelos y nietos riendo juntos alrededor de la mesa"
            loading="lazy"
            className="absolute -bottom-12 -right-4 w-3/5 rotate-2 rounded-2xl border-4 border-white object-cover shadow-[0_24px_50px_-16px_rgba(12,95,138,0.4)] transition-transform duration-500 hover:rotate-0 sm:-right-10"
          />
          <div className="absolute -bottom-8 left-6 rounded-2xl bg-[#0C5F8A] px-5 py-3 shadow-xl">
            <p className="font-display text-sm font-semibold text-white">Trato de familia,</p>
            <p className="font-display text-sm font-semibold text-[#F5B21B]">no de call center</p>
          </div>
        </Reveal>

        <div className="grid gap-6 pt-10 sm:grid-cols-2 lg:pt-0">
          {RAZONES.map((r, i) => (
            <Reveal key={r.titulo} delay={i * 0.1} className="h-full">
              <div
                data-testid={`porque-card-${i}`}
                className="group h-full rounded-2xl border border-[#1BA8E0]/15 bg-white p-7 shadow-[0_10px_30px_-5px_rgba(12,95,138,0.08)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_22px_44px_-12px_rgba(12,95,138,0.2)]"
              >
                <div className="relative inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E8F6FD] transition-colors duration-500 group-hover:bg-[#1BA8E0]">
                  <r.icon className="h-7 w-7 text-[#1BA8E0] transition-colors duration-500 group-hover:text-white" strokeWidth={1.8} />
                  <span className="absolute -right-1 -top-1 h-3.5 w-3.5 rounded-full border-2 border-white bg-[#F5B21B]" />
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-[#0C5F8A]">{r.titulo}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[#2E3338]/75">{r.texto}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
